<template>
    <div>
        <!-- Таблица -->
        <basic-table
            show-top-button="true"
            @top-button-click="createProjectOpenModal"
        >
            <template v-slot:table_cards_header>
                <h5>Projects List</h5>
            </template>
            <template v-slot:table_rows_header>
                <tr class="border-bottom-primary">
                    <th scope="col">Id</th>
                    <th scope="col">Project title</th>
                    <th scope="col">Client name</th>
                    <th scope="col">Start date</th>
                    <th scope="col">End date</th>
                    <th scope="col">Status</th>
                    <th scope="col">Actions</th>
                </tr>
            </template>
            <template v-slot:table_rows_data>
                <tr v-if="projects === null">
                    <td colspan="7" class="text-center">Empty table</td>
                </tr>
                <tr v-else v-for="(project, index) in projects" :key="project.id">
                    <td>{{ project.id }}</td>
                    <td>{{ project.project_title }}</td>
                    <td>{{ project.client_name }}</td>
                    <td>{{ project.start_date }}</td>
                    <td>{{ project.end_date }}</td>
                    <td>
                        <span
                            :class="project.is_disabled ? 'badge bg-danger' : 'badge bg-success'"
                        >
                            {{ project.is_disabled ? 'Disabled' : 'Enabled' }}
                        </span>
                    </td>
                    <td>
                        <ul class="action">
                            <!-- Редактирование -->
                            <li class="edit">
                                <a
                                    href="#"
                                    @click="setProjectToEdit(project)"
                                    data-bs-toggle="modal"
                                    data-bs-target="#edit-modal"
                                >
                                    <i class="icon-pencil-alt"></i>
                                </a>
                            </li>
                            <!-- Удаление -->
                            <li class="delete">
                                <a @click="setProjectId(project, index)" data-bs-toggle="modal" data-bs-target="#delete-modal" href="#">
                                    <i class="icon-trash"></i>
                                </a>
                            </li>
                        </ul>
                    </td>
                </tr>
            </template>
        </basic-table>

        <!-- Модальное окно для добавления -->
        <basic-modal title="Add Project" target-id="create-modal" set-class="modal-lg">
            <template v-slot:modal_body>
                <create-project @stored="fetchAll" />
            </template>
        </basic-modal>

        <!-- Модальное окно для редактирования -->
        <basic-modal title="Edit Project" target-id="edit-modal" set-class="modal-lg">
            <template v-slot:modal_body>
                <create-project
                    ref="projectForm"
                    :is-edit="true"
                    :project="projectItem"
                    :show-buttons="false"
                    @stored="fetchAll"
                />
            </template>
            <template v-slot:first_button>
                <button @click="saveProjectData" class="btn btn-outline-info">Save</button>
            </template>
        </basic-modal>

        <!-- Модальное окно для удаления -->
        <basic-modal
            title="Delete Project"
            target-id="delete-modal"
            :modal-body="deleteMessage"
        >
            <template v-slot:first_button>
                <button
                    type="button"
                    class="btn btn-outline-danger"
                    @click="deleteProject(this.deleteProjectIdRow)"
                >
                    Delete
                </button>
            </template>
        </basic-modal>
    </div>
</template>

<script>
// Импорты компонентов и логики остаются такими же
import BasicTable from "../Basic/BasicTable.vue";
import CreateProject from "./CreateProject.vue";
import BasicModal from "../Basic/BasicModal.vue";
import {createToaster} from "@meforma/vue-toaster";

const toaster = createToaster({});

export default {
    name: "ProjectsList",
    components: {
        BasicTable,
        CreateProject,
        BasicModal,
    },
    data() {
        return {
            projects: null,
            deleteProjectIdRow: null,
            projectItem: {},
            deleteMessage: "",
        };
    },
    methods: {
        fetchAll() {
            axios.get('/projects/list/get').then(({ data }) => {
                this.projects = data.items;

                $('#create-modal').modal('hide');
                $('#edit-modal').modal('hide');
            });
        },

        setProjectToEdit(project) {
            this.projectItem = Object.assign({}, project);
        },

        setProjectId(project, index) {
            this.deleteProjectIdRow = index;
            this.projectItem = Object.assign({}, project);
            this.deleteMessage = `Are you sure you want to delete "${project.project_title}"?`;
        },

        deleteProject(index) {
            const id = this.projects[index].id;
            axios.post('/projects/delete', { project_id: id }).then(() => {
                this.projects.splice(index, 1);
                toaster.show("Project deleted successfully", { type: "success" });

                $('#delete-modal').modal('hide');
            });
        },

        saveProjectData() {
            this.$refs.projectForm.add(); // вызов метода обновления/добавления
        },

        createProjectOpenModal() {
            $('#create-modal').modal('show'); // Показываем модальное окно для добавления
        },
    },
    mounted() {
        this.fetchAll();
    },
};
</script>
